import { Box } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLButton } from "OLButton";
import { CustomAttributesModal } from "components/Layout/Transaction/SingleTransaction/CustomAttributesModal";
import OverflowChipTooltip from "components/Tooltips/OverflowChipTooltip";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { useState } from "react";

const ItemsStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    toggleSeeAll: {
      height: "32px",
      padding: theme.spacing(0, 4),
      fontSize: "13px",
      fontWeight: 500,
      lineHeight: "22px",
      textDecoration: "underline",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    chipWrapper: {
      maxWidth: "130px",
    },
    labels: {
      alignItems: "center",
      display: "flex",
      flexWrap: "nowrap",
      gap: theme.spacing(4),
    },
  }),
);

export function AttributeChips({ items }: { items: any }) {
  const classes = ItemsStyles();
  const [open, setOpen] = useState(false);
  const { message } = useMessage();
  const itemsKeys = Object.keys(items);

  return (
    <>
      <Box className={classes.labels}>
        {itemsKeys?.slice(0, 2).map((key, index) => (
          <Box className={classes.chipWrapper} key={index}>
            <OverflowChipTooltip
              placement="top"
              label={`${key}: ${items[key]}`}
              data-test-id={`attribute-chip-${index}`}
            />
          </Box>
        ))}
        {itemsKeys?.length > 2 && (
          <OLButton
            className={classes.toggleSeeAll}
            onClick={() => {
              setOpen(true);
            }}
          >
            {message(
              { id: "showAllElements" },
              { elements: itemsKeys?.length },
            )}
          </OLButton>
        )}
      </Box>
      <CustomAttributesModal
        open={open}
        close={() => {
          setOpen(false);
        }}
        customAttributes={itemsKeys?.map((key) => ({
          key,
          value: items[key],
        }))}
      />
    </>
  );
}
